
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { FormProfile } from './formProfile';

export const ClienteProfilePage = () => {
  const { id } = useParams(); 

  return (
    <ClienteFormState>
        <br />
        <FormProfile title="Registrarse" />
    </ClienteFormState>
  );
};
